import React from "react";
import { range } from "../../lib/utils";
import { MAX_MISTAKES } from "../../lib/constants";
import { GameStatusContext } from "../../providers/GameStatus";

function SingleMistakeDisplay({ isUsed }) {
    return (
        <div className="flex items-center justify-center w-6 h-6 sm:w-8 sm:h-8">
            {isUsed ? (
                <div className="w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-slate-700 ring-2 ring-slate-800" />
            ) : (
                <div className="w-3 h-3 sm:w-4 sm:h-4 rounded-full bg-emerald-400 shadow-[0_0_10px_rgba(52,211,153,0.5)]" />
            )}
        </div>
    );
}

function NumberOfMistakesDisplay() {
    const { numMistakesUsed } = React.useContext(GameStatusContext);
    const mistakeRange = range(MAX_MISTAKES);
    return (
        <div className="flex flex-row gap-x-2 sm:gap-x-3 justify-center items-center py-2">
            <p className="text-base sm:text-lg font-medium text-slate-300">Mistakes remaining:</p>
            <div className="flex gap-x-2">
                {mistakeRange.map((el) => (
                    <SingleMistakeDisplay key={el} isUsed={el < numMistakesUsed} />
                ))}
            </div>
        </div>
    );
}

export default NumberOfMistakesDisplay;